import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FlagIcon from '@mui/icons-material/Flag';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

import { useNavigate } from 'react-router-dom';


  

function AppDrawer() {
    const navigate = useNavigate();

    const handleNavItemClick = (item) => {
        console.log(item);
        
        // Add routing logic here
        if (item === 'General') {
            navigate('/Profile');
        }
        if (item === 'Financial Goals') {
            navigate('/Goals');
        }
    
    };

    const drawerList = () => (
        <Box sx={{ overflow: 'auto' }}>
            <List>
            {['General', 'Financial Goals'].map((text, index) => (
                <ListItem button key={text} onClick={() => handleNavItemClick(text)}>
                <ListItemIcon>{index % 2 === 0 ? <AccountCircleIcon /> : <FlagIcon />}</ListItemIcon>
                <ListItemText primary={text} />
                </ListItem>
            ))}
            </List>
        </Box>
        );

    return (
   
        <Drawer variant="permanent" sx={{
            width: 250,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { width: 250, boxSizing: 'border-box' },
          }}>
        <Toolbar />
        
        {drawerList()}
        
        </Drawer>

    );
}

export default AppDrawer;


